import Endpoint from "../../services/api/endpoint";
import { IProject } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IProject>(Endpoint.Projects, Endpoint.ProjectsList);